<template>
  <div :id="`article_list_${type}`" class="article_list">
    <div v-if="loading" class="loader my-5" />
    <template v-else-if="list && list.length > 0">
      <!-- <ul v-if="type === 'events'" class="year_selectors list-unstyled m-0">
        <li v-for="current_year in years" :key="current_year" class="d-inline-block">
          <b-button
            variant="link"
            :class="{ 'selected': current_year === selectedYear }"
            class="year_selector"
            v-on:click="selectYear(current_year)"
          >{{ current_year }}</b-button>
        </li>
      </ul> -->
      <template v-if="collapsible">
        <div class="float-right">
          <button type="button" class="btn btn-link toggle_btn" @click="toggleAll()">
            <template v-if="collapsed_all">
              <i class="fa fa-plus" />
              {{ $t("component.toggle_btn.show_details") }}
            </template>
            <template v-else>
              <i class="fa fa-minus" />
              {{ $t("component.toggle_btn.hide_details") }}
            </template>
          </button>
        </div>
        <h3 class="text-dark mb-2">{{ heading }}</h3>
        <b-card
          v-for="item in list"
          :id="`${type}_${item.article_id}`"
          :key="`${type}_${item.article_id}`"
          no-body
        >
          <b-card-header
            v-b-toggle="`collapse_${item.article_id}`"
            header-tag="div"
            class="headline px-1 py-2"
            role="tab"
          >
            <h6 class="font-weight-normal text-dark ml-2">{{ getDataValue('headline', item) }}</h6>
          </b-card-header>
          <b-collapse :id="`collapse_${item.article_id}`" :visible="!collapsed_all" role="tabpanel">
            <b-card-body>
              <div
                v-if="item.logo || item.image"
                :id="`article_images_${item.article_id}`"
                class="article_images"
              >
                <div class="row align-items-center">
                  <div class="col-sm-5 text-center pb-3">
                    <b-img
                      v-if="item.logo"
                      :id="`bene_logo_${item.article_id}`"
                      class="logo"
                      :src="getAssetLink(item.logo)"
                      :blank-src="$config.lazyload.grid"
                      @error.native="onImgError"
                    />
                  </div>
                  <div class="col-sm-7 pb-3">
                    <b-img
                      v-if="item.image"
                      :id="`bene_photo_${item.article_id}`"
                      class="photo"
                      :src="getAssetLink(item.image)"
                      :blank-src="$config.lazyload.grid"
                      @error.native="onImgError"
                    />
                  </div>
                </div>
              </div>
              <div class="subheadline">{{ getDataValue('subheadline', item) }}</div>
              <div v-lazy-container="{ selector: 'img' }" class="description" v-html="item.body" />
              <div :id="`links_${item.article_id}`" class="links mt-3">
                <template v-for="link_type in link_types">
                  <a
                    v-if="item[link_type.key]"
                    :id="`link_${link_type.key}_${item.article_id}`"
                    :key="`link_${link_type.key}`"
                    :href="item[link_type.key]"
                    target="_blank"
                    :class="`link link_${link_type.key}`"
                  >
                    <div class="link_icon">
                      <img :src="link_type.image" />
                    </div>
                    <div class="link_text">{{ $t(`component.link.${link_type.key}`) }}</div>
                    <div class="link_arrow">
                      <img src="/images/arrow_red.gif" />
                    </div>
                  </a>
                </template>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </template>
      <ul v-else v-lazy-container="{ selector: 'img' }" class="tabContentList list-unstyled m-0">
        <!-- <li
          v-for="item in filteredList()"
          :key="`${type}_${item.article_id}`"
          :id="`${type}_${item.article_id}`"
        >-->
        <li
          v-for="item in list"
          :id="`${type}_${item.article_id}`"
          :key="`${type}_${item.article_id}`"
        >
          <div class="container">
            <div class="row">
              <div v-if="show_image" class="col-sm-4 mb-3">
                <div class="thumbnail-img">
                  <!-- <template v-if="type == 'events'">
                    <a
                      class="d-block gallery_photo_trigger"
                      :id="`event_photo_${item.article_id}`"
                      data-fancybox="gallery"
                      :data-options="fancyOptions"
                      :data-caption="getDataValue('headline', item)"
                      :href="getAssetLink(item.image)"
                      v-if="item.image"
                    >
                      <img
                        class="thumb w-100"
                        :id="`event_thumb_${item.article_id}`"
                        :src="getAssetLink(item.image_thumb || item.thumb_image)"
                      >
                    </a>
                  </template>
                  <template v-else>-->
                  <CustomLink
                    v-if="item.image"
                    :id="`photo_${item.article_id}`"
                    class="d-block"
                    target="_blank"
                    :url="getItemUrl(item)"
                  >
                    <img
                      :id="`thumb_${item.article_id}`"
                      class="thumb w-100"
                      :src="getAssetLink(item.image_thumb || item.thumb_image)"
                    />
                  </CustomLink>
                  <!-- </template> -->
                </div>
              </div>
              <div :class="show_image?'col-sm-8 mb-3':'col-12'">
                <div class="article_headline text-osc">
                  <!-- <template v-if="type == 'events'">{{ getDataValue('headline', item) }}</template> -->
                  <CustomLink
                    target="_blank"
                    :url="getItemUrl(item)"
                  >{{ getDataValue('headline', item) }}</CustomLink>
                </div>
                <div
                  v-if="(type === 'events' || type === 'news') && item.published_at"
                  class="date text-osc"
                >{{ formatDate(item.published_at) }}</div>
                <div :id="type" class="article_body">
                  <div v-if="show_image" v-lazy-container="{ selector: 'img' }" v-html="item.body" />
                  <div v-else-if="item.ref_url">
                    <a
                      :href="item.ref_url"
                      target="_blank"
                      class="read_more_link text-osc"
                    >{{ $t("message.read_more") }} >></a>
                  </div>
                  <div v-if="type === 'events' && item.url" class="mt-2">
                    <CustomLink
                      target="_blank"
                      class="read_more_link text-osc"
                      :url="item.url"
                    >{{ $t("message.read_more") }} >></CustomLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </template>
    <template v-else>
      <h3 v-if="collapsible" class="text-dark mb-2">{{ heading }}</h3>
      <div class="text-center py-4">{{ $t('page.no_data') }}</div>
    </template>
  </div>
</template>
<script>
import fancyBox from "vue-fancybox"; //eslint-disable-line
import * as $ from "jquery";
import moment from "moment";
import _ from "lodash";
import CustomLink from "@/components/CustomLink";

export default {
  name: "ArticleList",
  components: { CustomLink },
  props: ["heading", "type", "segment", "endpoint", "osc_year"],
  data() {
    var collapsible = this.type == "beneficiaries";
    var collapsed_all = false;
    if (collapsible) {
      var to = this.$router.history.current;
      if (!to.params.segment) {
        collapsed_all = true;
      }
    }
    return {
      loading: false,
      list: [],
      show_image: this.type != "news",
      collapsible: collapsible,
      collapsed_all: collapsed_all,
      link_types: [
        { key: "article_url", image: "/images/icons/link_icon_01.jpg" },
        { key: "rthk_url", image: "/images/icons/link_icon_02.jpg" },
        { key: "ngo_url", image: "/images/icons/link_icon_03.jpg" },
        { key: "wise_giving_url", image: "/images/icons/link_icon_04.jpg" }
      ],
      year: moment().startOf("year"),
      selectedYear: localStorage.osc_year,
      years: [],
      fancyOptions: this.getImageOptions()
    };
  },
  mounted() {
    this.loading = true;
    this.$http
      .get(this.endpoint, { params: { osc_year: this.osc_year } })
      .then(response => {
        var json = response.data;
        this.list = json.success && json.data ? json.data : null;
        if (this.list) {
          this.filteredYears();
        }
      })
      .finally(() => {
        this.loading = false;
        let hash = this.$route.hash;
        if (this.list && !this.collapsed_all && hash.startsWith("#b")) {
          setTimeout(() => {
            this.scrollTo(
              "#" +
                $(".collapse.show#collapse_" + hash.substr(2))
                  .closest(".card")
                  .attr("id")
            );
          }, 500);
        }
      });
  },
  methods: {
    selectYear(current_year) {
      this.selectedYear = current_year;
    },
    filteredYears() {
      this.years = _.uniq(_.map(this.list, "osc_year"));
      this.selectedYear = this.years.length > 0 ? this.years[0] : null;
    },
    filteredList() {
      if (this.type == "events") {
        let __this = this;
        return this.list.filter(item => {
          return item.osc_year == __this.selectedYear;
        });
      }
      return this.list;
    },
    getItemUrl(item) {
      let url = null;
      switch (this.type) {
        case "achievement":
          url = `/article/${this.type}/${item.article_id}`;
          break;
        case "news":
          url = item.ref_url;
          break;
        default:
          url = item.url;
          break;
      }
      return url;
    },
    formatDate(date) {
      var val = moment(date);
      let format = "";
      if (this.$i18n.locale == "en") {
        format = "D MMM";
        if (val.isBefore(this.year)) {
          format += ", YYYY";
        }
      } else {
        format = "MM-DD";
        if (val.isBefore(this.year)) {
          format = "YYYY-" + format;
        }
      }
      return val.format(format);
    },
    toggleAll() {
      this.collapsed_all = !this.collapsed_all;
    },
    onImgError(e) {
      e.target.parentNode.style.display = "none";
    },
    getImageOptions() {
      return JSON.stringify({
        loop: true,
        thumbs: { autoStart: true, axis: "x" },
        buttons: ["slideShow", "thumbs", "close"]
      });
    }
  }
};
</script>
<style src="../../public/fancybox/jquery.fancybox.min.css"></style>
<style scoped lang="scss" src="../assets/scss/article-list.scss"></style>
<style lang="scss">
// .page#events .articleBodyFullWidth {
//   padding-top: 50px;

//   .article_list#article_list_events {
//     position: static;
//   }
//   .year_selectors {
//     position: absolute;
//     left: 0;
//     right: 0;
//     top: 75px;
//   }
//   .year_selector {
//     line-height: 20px;
//     padding: 0;
//     margin-right: 10px;
//   }
//   .year_selector.selected {
//     font-weight: bold;
//   }
//   .year_selectors > li:not(:last-child) .year_selector:after {
//     padding-left: 10px;
//     content: "|";
//   }
// }
</style>
